var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.833 11.6725V22.1667H8.16634V5.83333H15.1547V8.73833C15.1547 9.20246 15.339 9.64758 15.6672 9.97577C15.9954 10.304 16.4405 10.4883 16.9047 10.4883H22.1547V9.87933C22.1547 9.53283 22.0007 9.205 21.7358 8.98333L15.8162 4.04133C15.3962 3.69133 14.8677 3.5 14.3205 3.5H8.16634C7.5475 3.5 6.95401 3.74583 6.51643 4.18342C6.07884 4.621 5.83301 5.21449 5.83301 5.83333V22.1667C5.83301 22.7855 6.07884 23.379 6.51643 23.8166C6.95401 24.2542 7.5475 24.5 8.16634 24.5H19.833C20.4518 24.5 21.0453 24.2542 21.4829 23.8166C21.9205 23.379 22.1663 22.7855 22.1663 22.1667V11.6725H19.833Z",
    fill: "#6B778C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4997 14H10.4997C9.85534 14 9.33301 14.5223 9.33301 15.1667C9.33301 15.811 9.85534 16.3333 10.4997 16.3333H17.4997C18.144 16.3333 18.6663 15.811 18.6663 15.1667C18.6663 14.5223 18.144 14 17.4997 14Z",
    fill: "#6B778C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.833 17.5H10.4997C9.85534 17.5 9.33301 18.0223 9.33301 18.6667C9.33301 19.311 9.85534 19.8333 10.4997 19.8333H12.833C13.4773 19.8333 13.9997 19.311 13.9997 18.6667C13.9997 18.0223 13.4773 17.5 12.833 17.5Z",
    fill: "#6B778C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/fileIcon.3185b94d.svg";
export { ForwardRef as ReactComponent };